/**
 * Transitions pures du buffer de saisie du pavé numérique (PinPad), isolées
 * du composant pour rester testables sans DOM : la suite Vitest de ce dépôt
 * tourne sous `environment: "node"` (jsdom n'est pas installé), donc tout ce
 * qui touche au rendu React reste non testé à ce niveau — seule cette
 * logique d'état l'est.
 */

/** Ajoute un chiffre, sans dépasser la longueur attendue du code. */
export function appendPinDigit(pin: string, digit: string, length: number): string {
  if (pin.length >= length) return pin;
  return pin + digit;
}

/** Retire le dernier chiffre saisi ; no-op sur un buffer déjà vide. */
export function backspacePinDigit(pin: string): string {
  return pin.slice(0, -1);
}
